import React from "react";
import localeText from "../../../../../../locale";
import EconomicCircleMemberCard from "../EconomicCircleMemberCard/EconomicCircleMemberCard";
import "./EconomicCircleNetworkHighlights.css";

/**
 * Section "Destaques da rede (Top 5)" – grid of 5 slots (member card or placeholder).
 * @param {Array} members - Up to 5 members (by date, already sliced)
 */
const EconomicCircleNetworkHighlights = ({ members = [] }) => {
  const slots = [0, 1, 2, 3, 4].map((i) => members[i] ?? null);

  return (
    <div className="economic-circle-network-highlights mb-4">
      <div className="text-sm font-semibold mb-3" style={{ color: "var(--theme-text)" }}>
        {localeText("networkHighlightsTop5") || "Destaques da rede (Top 5)"}
      </div>
      <div className="grid">
        {slots.map((member, i) => (
          <div key={i} className="col-12 sm:col-6 lg:col-2">
            <div
              className="border-round-md p-3 text-center economic-circle-member-card economic-circle-highlight-card h-full"
              style={{
                minHeight: "150px",
                border: member
                  ? "2px solid var(--theme-border, #EBEBEB)"
                  : "2px dashed var(--theme-border, #EBEBEB)",
                minWidth: "150px",
              }}
            >
              <EconomicCircleMemberCard member={member} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EconomicCircleNetworkHighlights;
